import { Endpoint } from '../endpoint';
import { AssistantId, AssistantResponse, AssistantStats } from '@business/entities/assistant';

export function fetchAssistants(search?: string) {
  return Endpoint.get<AssistantResponse[]>(`@gc/assistants`, { params: { search: '' } });
}

export function fetchAssistant(id: AssistantId) {
  return Endpoint.get<AssistantResponse>(`@gc/assistants/assistant/${id}`);
}

export function createAssistant(data: Partial<AssistantResponse>) {
  return Endpoint.post<AssistantResponse>(`@gc/assistants`, { data });
}

export function updateAssistant(id: AssistantId, data: Partial<AssistantResponse>) {
  return Endpoint.patch<AssistantResponse>(`@gc/assistants/${id}`, { data });
}

export function deleteAssistant(id: AssistantId) {
  return Endpoint.delete<void>(`@gc/assistants/${id}`);
}

export function stats(date: string, assistantIds: string[], customerIds: string[]) {
  return Endpoint.post<AssistantStats>(`@gc/assistants/stats`, {
    data: { date, assistantIds, customerIds },
  });
}

export function fetchVersions(assistantId: AssistantId) {
  return Endpoint.get<AssistantResponse[]>(`@gc/assistants/versions/${assistantId}`);
}

export function revertVersion(id: AssistantId, versionId: string) {
  return Endpoint.post<AssistantResponse>(`@gc/assistants/revert-version/${id}`, { data: { versionId } });
}

export function search(query: string, limit: number, types: string[] = []) {
  return Endpoint.post<any>(`@gc/assistants/search`, { data: { query, limit, types } });
}

export function start(assistanId: string, threadId: string) {
  return Endpoint.post<any>(`@gc/assistants/start/${assistanId}`, { data: { threadId } });
}

export function stop(assistantId: string, threadId: string, lastResponseId: string) {
  return Endpoint.post<any>(`@gc/assistants/stop/${assistantId}`, { data: { threadId, lastResponseId } });
}

export function track(assistanId: string, threadId: string, time = 0) {
  return Endpoint.post<any>(`@gc/assistants/track/${assistanId}`, { data: { threadId, time } });
}

export function onNewMessage(assistantId: string, lastResponseId: string, sessionId: string) {
  return Endpoint.post<any>(`@gc/assistants/on-new-message/${assistantId}`, { data: { lastResponseId, sessionId } });
}
